import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { FiEdit, FiCheck, FiX } from "react-icons/fi";

interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

interface Subscription {
  subscription_id: number;
  subscription_name: string;
  start_date: string;
  end_date: string | null;
  is_active: boolean;
  role_limits:RoleLimits;
}

interface RoleLimits {
    admin_user_count: number;
    tutor_user_count: number;
    student_user_count: number;
  }

interface SubscriptionQueue{
    subscription_queue_id: number;
    new_subscription_name: string;
    start_date: string;
    end_date: string;
    is_active: boolean;
    role_limits:RoleLimits;
}
const SubscriptionManager: React.FC = () => {
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);

  const { isOpen, onOpen, onClose } = useDisclosure();

  // Second modal disclosure for removing an item from the subscription queue
  const { isOpen: isRemoveModalOpen, onOpen: onRemoveModalOpen, onClose: onRemoveModalClose } = useDisclosure();

  // New disclosure for the collapsible panel
  const { isOpen: isPanelOpen, onToggle } = useDisclosure(); // For the collapsible panel

  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState<number | null>(null);
  const [subscriptionQueue, setsubscriptionQueue] = useState<SubscriptionQueue[]>([]);
  const [selectedSubscriptionQueueId, setSelectedSubscriptionQueueId] = useState<number | null>(null);
  const [newSubscriptionName, setNewSubscriptionName] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [adminUserCount, setAdminUserCount] = useState<string>('');
  const [tutorUserCount, setTutorUserCount] = useState<string>('');
  const [studentUserCount, setStudentUserCount] = useState<string>('');
  const toast = useToast();

  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  useEffect(() => {
    const fetchTenants = async () => {
      try {
        const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
        const response = await axios.get(tenantsapiurl, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        const filteredTenants = response.data.filter((tenant: Tenant) => tenant.tenant_id !== 1);
        setTenants(filteredTenants);
        if (filteredTenants.length > 0) {
          setSelectedTenant(filteredTenants[0].tenant_id);
        }
      } catch (error) {
        console.error("Failed to load tenants", error);
      }
    };
    fetchTenants();
  }, []);

  const fetchSubscriptions = async () => {
    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
      const response = await axios.get(tenantsapiurl + `/${selectedTenant}/subscriptions`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setSubscriptions(response.data);
    } catch (error) {
      console.error("Failed to load Subscriptions", error);
    }
  };

  const fetchSubscriptionQueue = async () => {
    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
      const response = await axios.get(tenantsapiurl + `/${selectedTenant}/subscription-queue`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      console.log("Subscription-Queue API Results",response);
      setsubscriptionQueue(response.data);
    } catch (error) {
      console.error("Failed to load Subscription Queue", error);
    }
  };

  useEffect(() => {
    if (selectedTenant) {

      fetchSubscriptions();

      fetchSubscriptionQueue();

    }
  }, [selectedTenant]);

  const handleDeactivateSubcription = async () => {
    if (selectedSubscriptionId) {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/subscription-deactivate/${selectedSubscriptionId}`,
          {},
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );

        if (response.data.is_deactivated) {
          toast({
            title: 'Success',
            description: 'Subscription has been deactivated.',
            status: 'success',
            duration: 5000,
            isClosable: true,
          });

          // Refresh subscriptions after deactivation
          setSubscriptions((prevSubscriptions) =>
            prevSubscriptions.map((sub) =>
              sub.subscription_id === selectedSubscriptionId
                ? { ...sub, is_active: false }
                : sub
            )
          );
        }
      } catch (error) {
        console.error("Failed to deactivate subscription", error);
        toast({
          title: 'Error',
          description: 'Failed to deactivate subscription.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    }
    onClose();
}

const handleDeactivateSubcriptionQueue = async () => {
    if (selectedSubscriptionQueueId) {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/subscription-queue-remove/${selectedSubscriptionQueueId}`,
          {},
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );

        if (response.data.is_removed) {
          toast({
            title: 'Success',
            description: 'Subscription Queue Item has been removed.',
            status: 'success',
            duration: 5000,
            isClosable: true,
          });

          // Refresh subscription queue after deactivation
          setsubscriptionQueue((prevsubscriptionQueue) =>
            prevsubscriptionQueue.filter(
              (sub) => sub.subscription_queue_id !== selectedSubscriptionQueueId
            )
          );
        }
      } catch (error) {
        console.error("Failed to remove Subscription Queue Item", error);
        toast({
          title: 'Error',
          description: 'Failed to remove Subscription Queue Item.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    }
    onRemoveModalClose(); // Close the second modal after action
}

const handleSubscriptionSubmit = async () => {
    if (!newSubscriptionName || !startDate || !endDate) {
      toast({
        title: 'Error',
        description: 'Please fill in all required fields.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const subscriptionQueueData = {
        new_subscription_name: newSubscriptionName,
        start_date: new Date(startDate).toISOString(),
        end_date: new Date(endDate).toISOString(),
        role_limits: {
          admin_user_count: adminUserCount,
          tutor_user_count: tutorUserCount,
          student_user_count: studentUserCount
        }, 
        tenant_id:selectedTenant,
        is_active: true
      };

    try {
        const subscriptionqapiurl = `${process.env.REACT_APP_API_URL}/subscription-queue-push`;
        const response = await axios.post(subscriptionqapiurl, subscriptionQueueData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
      toast({
        title: 'Success',
        description: 'Subscription change request has been submitted successfully.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      // Clear form after successful submission
      setNewSubscriptionName('');
      setStartDate('');
      setEndDate('');
      setAdminUserCount('');
      setTutorUserCount('');
      setStudentUserCount('');

      if (selectedTenant) {
        fetchSubscriptions();
        fetchSubscriptionQueue();
      }
      
    } catch (error) {
      console.error('Failed to submit subscription change request', error);
      toast({
        title: 'Error',
        description: 'Failed to submit subscription change request.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };
  
  // Typing the setter function and the event handler parameter
  const handleNumberInputChange = (
    setter: React.Dispatch<React.SetStateAction<string>>
  ) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    // Only set if value is not negative and is a number
    if (!isNaN(value) && value >= 0) {
      setter(value.toString());
    } else if (e.target.value === '') {
      setter(''); // Allow clearing the input
    }
  };
  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>Subscription Manager</Heading>
      </VStack>

      <Box  borderColor={"gray.300"} mt={4} borderWidth={1} borderRadius="sm">
        {/* Tenant selection */}
        <HStack mt={4} mb={4} ml={2} mr={2}>
        <Text fontSize="sm" minWidth={"120px"}>Select Tenant:</Text>
        <Select borderRadius="sm"
          placeholder="Select Tenant"
          size="sm" fontSize="sm"
          value={selectedTenant || ''}
          onChange={(e) => setSelectedTenant(parseInt(e.target.value))}
        >
          {tenants.map((tenant) => (
            <option key={tenant.tenant_id} value={tenant.tenant_id}>
              {tenant.name}
            </option>
          ))}
        </Select>
        </HStack>
        </Box>
        <Box mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm" >
        <Box mt={4} minHeight={"150px"} ml={2} mr={2}>
            <Text fontSize="sm" fontWeight="bold">Subscriptions for the Tenant</Text>
            {/* Subscription Table */}
            <Table variant="simple" mt={1   } maxHeight={"300px"}  
            borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
            <Thead>
            <Tr bgColor={tableHeaderbg}>
                <Th>Subscription</Th>
                <Th>Start Date</Th>
                <Th>End Date</Th>
                <Th>Status</Th>
                <Th>Admin #</Th>
                <Th>Tutor #</Th>
                <Th>Student #</Th>
                <Th>Action</Th>
                </Tr>
            </Thead>
            <Tbody>
                {subscriptions.map((subscription) => (
                <Tr key={subscription.subscription_id} fontSize="sm">
                    <Td>{subscription.subscription_name}</Td>
                    <Td>{new Date(subscription.start_date).toLocaleDateString()}</Td>
                    <Td>{subscription.end_date ? new Date(subscription.end_date).toLocaleDateString() : 'Active'}</Td>
                    <Td>{subscription.is_active ? 'Active' : 'Inactive'}</Td>
                    <Td>{subscription.role_limits.admin_user_count}</Td>
                    <Td>{subscription.role_limits.tutor_user_count}</Td>
                    <Td>{subscription.role_limits.student_user_count}</Td>
                    <Td>
                  {subscription.is_active && (
                    <Button colorScheme="red" size="sm" fontSize="sm" borderRadius="sm" onClick={() => {
                      setSelectedSubscriptionId(subscription.subscription_id);
                      onOpen();
                    }}>
                      Deactivate
                    </Button>
                  )}
                </Td>
                </Tr>
                ))}
            </Tbody>
            </Table>
        </Box>

            {/* Modal for deactivation confirmation */}
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Deactivate Subscription</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <Text>This subscription will be prematurely ended as of today. Do you want to proceed?</Text>
            </ModalBody>
            <ModalFooter>
                <Button colorScheme="blue" mr={3} onClick={onClose}>
                Cancel
                </Button>
                <Button colorScheme="red" onClick={handleDeactivateSubcription}>
                Deactivate
                </Button>
            </ModalFooter>
            </ModalContent>
        </Modal>

        <Box mt={4} minHeight={"150px"} ml={2} mr={2}>
            <Text fontSize="sm" fontWeight="bold">Subscription In Queue</Text>
            {/* Subscription Queue Table */}
            <Table variant="simple" mt={1} maxHeight={"300px"}  
            borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
            <Thead>
            <Tr bgColor={tableHeaderbg}>
                <Th>Subscription</Th>
                <Th>Start Date</Th>
                <Th>End Date</Th>
                <Th>Status</Th>
                <Th>Admin #</Th>
                <Th>Tutor #</Th>
                <Th>Student #</Th>
                <Th>Action</Th>
                </Tr>
            </Thead>
            <Tbody>
                {subscriptionQueue.map((queueItem, index) => (
                <Tr key={index}  fontSize="sm" // Control font size inside input
                >
                    <Td >{queueItem.new_subscription_name}</Td>
                    <Td>{new Date(queueItem.start_date).toLocaleDateString()}</Td>
                    <Td>{queueItem.end_date ? new Date(queueItem.end_date).toLocaleDateString() : 'Ongoing'}</Td>
                    <Td>{queueItem.is_active ? 'Queued' : 'Executed'}</Td>
                    <Td>{queueItem.role_limits.admin_user_count}</Td>
                    <Td>{queueItem.role_limits.tutor_user_count}</Td>
                    <Td>{queueItem.role_limits.student_user_count}</Td>
                    <Td>
                  {queueItem.is_active && (
                    <Button colorScheme="red" size="sm" fontSize="sm" borderRadius="sm" onClick={() => {
                      setSelectedSubscriptionQueueId(queueItem.subscription_queue_id);
                      onRemoveModalOpen(); // Open the remove modal
                    }}>
                      Remove
                    </Button>
                  )}
                </Td>
                </Tr>
                ))}
            </Tbody>
            </Table>
        </Box>

         {/* Second Modal for Remove from Queue Confirmation */}
      <Modal isOpen={isRemoveModalOpen} onClose={onRemoveModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Removal</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to remove this item from the queue?</Text>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onRemoveModalClose}>
              Cancel
            </Button>
            <Button colorScheme="red" onClick={handleDeactivateSubcriptionQueue} ml={3}>
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      </Box>

      <Box  mt={4}>
      {/* Collapsible button to toggle the form */}
      <Button
        borderRadius={"sm"} fontSize="sm" fontWeight="normal"
        onClick={onToggle} // Toggle the collapsible panel visibility
        aria-expanded={isPanelOpen}
        aria-controls="subscription-form-panel"
      >
        {isPanelOpen ? '- Subscription Request' : '+ Subscription Request'}
      </Button>
      
      {/* Collapsible panel with the form */}
      <Collapse in={isPanelOpen}>


        {/* Actions and Form for Subscription Change */}
        <Box borderColor="blue.200" borderStyle="dashed" borderWidth="2px" borderRadius="sm" p={4}>
          {/* Input Fields for Subscription Change */}
          <VStack mt={4} spacing={4}>
            <Input
              value={newSubscriptionName}
              onChange={(e) => setNewSubscriptionName(e.target.value)}
              placeholder="Subscription Name*"
              size="sm" // Control the input size here
              fontSize="sm" // Control font size inside input
            />
            
            <Input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              placeholder="Start Date*"
              size="sm" // Control the input size here
              fontSize="sm" // Control font size inside input
            />
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              placeholder="End Date*"
              size="sm" // Control the input size here
              fontSize="sm" // Control font size inside input
            />
            <Input
            type="number"
            value={adminUserCount}
            onChange={handleNumberInputChange(setAdminUserCount)}
            placeholder="Admin User Count*"
            size="sm" // Control the input size here
            fontSize="sm" // Control font size inside input
            />
            <Input
            type="number"
            value={tutorUserCount}
            onChange={handleNumberInputChange(setTutorUserCount)}
            placeholder="Tutor User Count*"
            size="sm" // Control the input size here
            fontSize="sm" // Control font size inside input
            />
            <Input
            type="number"
            value={studentUserCount}
            onChange={handleNumberInputChange(setStudentUserCount)}
            placeholder="Student User Count*"
            size="sm" // Control the input size here
            fontSize="sm" // Control font size inside input
            />
          </VStack>

          <Button mt={4} size="sm" fontSize="sm" colorScheme="blue" onClick={handleSubscriptionSubmit}>
            Submit Request
          </Button>
        </Box>

        </Collapse>
        </Box>
    </Box>
  );
};

export default SubscriptionManager;
